export const LABEL_CLASSNAME =
  "mb-2 block text-sm font-medium text-stone-700 dark:text-stone-300 cursor-pointer";
export const BUTTON_MAIN_CLASSNAME =
  "disabled:cursor-not-allowed w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-stone-500 cursor-pointer";
export const BUTTON_CLASSNAME = `bg-stone-600 hover:bg-stone-700 ${BUTTON_MAIN_CLASSNAME}`;
export const INPUT_CLASSNAME =
  "mb-4 appearance-none block w-full px-3 py-2 dark:text-stone-100 border dark:bg-stone-700 border-stone-300 dark:border-stone-800 rounded-md shadow-sm placeholder-stone-400 focus:outline-none focus:ring-stone-500 focus:border-stone-500 text-sm";
export const CENTERED_COLUMN_CLASSNAME = "flex flex-col items-center";
export const AUTH_LINK_CLASSNAME =
  "text-center font-medium text-stone-600 hover:text-stone-500";
